import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';

import Driver from "driver.js";
import "driver.js/dist/driver.min.css";


let driverOptions={
        className: "kaimo-driver", // 封装driver.js弹窗的类名
        animate: true, // 是否进行动画
        opacity: 0.5, // 背景不透明度(0表示只有弹窗，没有覆盖层)
        padding: 20, // 元素到边缘的距离
        allowClose: true, // 点击覆盖层是否应该关闭
        overlayClickNext: false, // 下一步点击覆盖层是否应该移动
        doneBtnText: "确定", // final按钮文本
        closeBtnText: "我知道了", // 关闭按钮文本
        stageBackground: "#fff", // 高亮元素背后的舞台背景颜色
        nextBtnText: "下一步", // 下一步按钮文本
        prevBtnText: "上一步", // 前一步按钮文本
        showButtons: true, // 在页脚不显示控制按钮
        keyboardControl: true, // 允许通过键盘控制(esc键关闭，箭头键移动)
        scrollIntoViewOptions: {}, // 如果可能的话，我们使用`scrollIntoView()`，如果你想要任何选项，在这里传递
        onHighlightStarted: (Element) => {}, // 当元素将要高亮时调用
        onHighlighted: (Element) => {}, // 当元素完全高亮时调用
        onDeselected: (Element) => {}, // 当元素被取消选择时调用
        onReset: (Element) => {}, // 当覆盖层即将被清除时调用
        onNext: (Element) => {}, // 当移动到下一个步骤时调用
        onPrevious: (Element) => {}, // 在任何步骤中移动到上一步时调用
}
import './permission' 
import 'element-ui/lib/theme-chalk/index.css';
import { resetForm ,getStatus,parseTime,handleClick,stepDefinition,formatNum} from "@/utils/sczn";
import i18n from './assets/i18n'
import './assets/element-variables.scss'
import { download } from '@/utils/request'
Vue.prototype.download = download
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.handleClick = handleClick
Vue.prototype.stepDefinition = stepDefinition
Vue.prototype.Driver = Driver
Vue.prototype.driverOptions = driverOptions
Vue.prototype.formatNum = formatNum




// 字典项回显
Vue.prototype.getStatus = getStatus
Vue.config.productionTip = false;
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
